import {
    GET_ATTENDEE_PAGE_DATA,
    CLEAR_ATTENDEE_PAGE_DATA,
    REQUEST_TRANSCRIPT_PENDING,
    REQUEST_TRANSCRIPT_SUCCESS,
    SET_ATTENDEE_PAGE_EVENT_TYPE
} from "../actiontypes";

import ApiPath from "../utils/Apis/ApiPath";
import { MEETING_TYPES } from "../utils/Generic/meetingTypes";

//! ATTENDEE PAGE REDUCER ACTION CREATORS
// Gets Data Necessary For Attendee Page
export const getAttendeePageInfo =
    (eventId, attNum) => async (dispatch, getState) => {
        const { sessionId, companyId } = getState().user.user;

        const eventDetailsUrl = `${ApiPath.urlApi}/api/events/getEventDetails?event_id=${eventId}&db=${ApiPath.db}&type=json&SessionId=${sessionId}&CompId=${companyId}`;
        const responseEventDetails = fetch(eventDetailsUrl);

        const attendeeActivityUrl = `${ApiPath.urlApi}/api/attendeeActivity/getActivity?attnum=${attNum}&db=${ApiPath.db}&type=json&SessionId=${sessionId}&CompId=${companyId}`;
        const responseAttendeeActivity = fetch(attendeeActivityUrl);

        const responses = await Promise.all([
            responseEventDetails,
            responseAttendeeActivity
        ]);

        const [dataED, dataAA] = await Promise.all(
            responses.map(response => response.json())
        );

        let data = {
            eventDetails: { ...dataED },
            attendeeActivity: { ...dataAA }
        };
        // Dispatch = Async
        dispatch({ type: GET_ATTENDEE_PAGE_DATA, payload: data });
    };

// Clears Attendee Page Info Object In State
export const clearAttendeePageInfo = () => {
    // Return = Sync
    return {
        type: CLEAR_ATTENDEE_PAGE_DATA
    };
};

export const getAttendeeTranscript = attNum => async (dispatch, getState) => {
    dispatch({ type: REQUEST_TRANSCRIPT_PENDING });

    const { sessionId, companyId } = getState().user.user;

    const response = await fetch(
        `${ApiPath.urlApi}/api/transcript/getTranscript?db=${ApiPath.db}&attnum=${attNum}&type=json&SessionId=${sessionId}&CompId=${companyId}`
    );

    const responseParsed = await response.json();

    dispatch({ type: REQUEST_TRANSCRIPT_SUCCESS, payload: responseParsed });
};

export const setAttendeePageEventType = eventType => {
    return {
        type: SET_ATTENDEE_PAGE_EVENT_TYPE,
        payload: MEETING_TYPES[eventType]
    };
};
